
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.328 12.813v-2.11h1.453A4.223 4.223 0 0024 6.484a4.223 4.223 0 00-4.219-4.218h-1.453V.156H5.672v2.11H4.266v1.406h1.406v2.11h12.656v-2.11h1.453a2.815 2.815 0 012.813 2.812 2.815 2.815 0 01-2.813 2.813h-1.453v-2.11H5.672v2.11H4.219A4.223 4.223 0 000 13.516a4.223 4.223 0 004.219 4.218h1.453v2.11h12.656v-2.11h1.406v-1.406h-1.406v-2.11H5.672v2.11H4.219a2.815 2.815 0 01-2.813-2.812 2.815 2.815 0 012.813-2.813h1.453v2.11h12.656z","fill":"#000"}}),_c('path',{attrs:{"d":"M20.496 15.623l1.406 1.406-1.406 1.407.994.994 2.508-2.4-2.508-2.401-.994.994zM.994 5.367l2.508-2.4L.994.567 0 1.56l1.406 1.406L0 4.373l.994.994z","fill":"#000"}})])
          )
        }
      }
    